class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    let now = new Date();
    let localHour = now.getHours();
    
    var cartLiveVisito = document.getElementById("cartLiveVisito").value;
    var randomValue1 = Math.floor(Math.random() * (20 - 5 + 1) + 5);
    var newcartLiveVisito = eval(cartLiveVisito)+eval(randomValue1);

    //Start Check if the hour is between 0 (midnight) and 15 (3:00 PM)
    if (localHour >= 0 && localHour < 15) {
       var newDataVal = ((newcartLiveVisito*40)/100);
       newDataVal=Math.round(newDataVal);
       newcartLiveVisito = (newcartLiveVisito-newDataVal);
       newcartLiveVisito=Math.round(newcartLiveVisito);
    }
    //End Check if the hour is between 0 (midnight) and 15 (3:00 PM)
    //console.log("newcartLiveVisito--->", newcartLiveVisito);
    document.getElementById("component-number-update-cart").innerHTML = '';
    document.getElementById("component-number-update-cart").innerHTML = newcartLiveVisito;
    
    document.body.classList.add('overflow-hidden');
    jQuery('.loader-icon').hide();
    jQuery('.pure_add_in_cart').find('span').eq(0).removeClass('hidden');
  }

  close() {
    this.classList.remove('active');
    
    //removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


document.addEventListener('DOMContentLoaded', function() {
    // Function to update the button state based on its text content
    const updateButtonState = (button) => {
        const spanElement = button.querySelector('span');
        if (spanElement) {
            const textContent = spanElement.textContent.trim();
            if (textContent === 'AÑADIDO ✓') {
                // Change the background color to #33C759 and text color to white
                button.style.backgroundColor = '#33C759';
                button.style.color = 'white';
            } else if (textContent === 'AÑADIR +' || textContent === 'ADICIONAR +') {
                // Revert the background color and text color to default
                button.style.backgroundColor = '';
                button.style.color = '';
            }
        }
    };

    // Function to start observing target nodes
    const startObserving = () => {
        const targetNodes = document.querySelectorAll('.upsell-add-button');
        targetNodes.forEach(targetNode => updateButtonState(targetNode));

        // Options for the observer (which mutations to observe)
        const config = { childList: true, subtree: true };

        // Callback function to execute when mutations are observed
        const callback = function(mutationsList, observer) {
            for (let mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    const targetNodes = document.querySelectorAll('.upsell-add-button');
                    targetNodes.forEach(targetNode => updateButtonState(targetNode));
                }
            }
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the entire document body for configured mutations
        observer.observe(document.body, config);
    };

    // Start observing target nodes
    startObserving();
});
